import React, { createContext, useContext, ReactNode } from 'react'
import type { MenuTheme } from '@/types'
import { MENU_THEMES } from '@/config/menuThemes'

interface MenuThemeContextType {
  theme: MenuTheme
}

const MenuThemeContext = createContext<MenuThemeContextType>({
  theme: MENU_THEMES.classic
})

export const useMenuTheme = () => useContext(MenuThemeContext)

interface MenuThemeProviderProps {
  theme: MenuTheme
  children: ReactNode
}

export const MenuThemeProvider: React.FC<MenuThemeProviderProps> = ({ theme, children }) => {
  return (
    <MenuThemeContext.Provider value={{ theme }}>
      {children}
    </MenuThemeContext.Provider>
  )
}
